import { Timestamp } from './timestamp';

export enum SubscriptionType {
  Trial = 'trial',
  // check if paid is still used
  Paid = 'paid',
  Premium = 'premium',
}

export enum Store {
  Stripe = 'stripe',
  Apple = 'apple',
  Promotional = 'promotional',
  AppStore = 'app_store',
}

export enum Interval {
  Week = 'week',
  TwoWeeks = 'two-weeks',
  Month = 'month',
  Year = 'year',
  Lifetime = 'lifetime',
}

export type UserSubscription = {
  type: SubscriptionType;
  store: Store;
  interval: Interval;
  stripeCustomerId?: string;
  managementUrl?: string;
  productId?: string;
  expiresAt: Timestamp | null;
  unsubscribedAt?: Timestamp;
  refundedAt?: Timestamp;
  purchasedAt: Timestamp;
};

export type SavedUserSubscription = {
  type: SubscriptionType;
  store: Store;
  stripeCustomerId?: string;
  managementUrl?: string;
  productId?: string;
  expiresAt: Timestamp | null;
  unsubscribedAt?: Timestamp;
  refundedAt?: Timestamp;
  purchasedAt: Timestamp;
};
